<template>
    <div class="hotline">
        <el-scrollbar height="100%">
            <div class="hotline_left">
                <div style="display: none" class="hotline_left_wordordeExplain" @click.stop="openWorkorderBzModal">
                    <div class="wordordeExplain_icon">
                        <img src="../../assets/images/explain.png" alt="">
                    </div>
                    <div class="wordordeExplain_modal" @click.stop :style="{'display':workorderBzModal}">
                        <div class="wordordeExplain_list" v-for="item in wordorderBzCon" :key="item.bzId">
                        <span class="icon-ico_man wordordeExplain_list_icon"><span class="path1"></span><span
                            class="path2"></span></span>
                            <div class="wordordeExplain_list_xq">
                                <div class="wordordeExplain_list_xqTop">
                                    <span>{{item.bzBzdw}}</span><span class="wordordeExplain_list_xqTop_name">{{item.bzBzr}}</span>
                                    <div class="wordordeExplain_list_xqTop_time">
                                        {{item.createTime}}
                                    </div>
                                    <div class="wordordeExplain_list_edit" v-if="item.sfbr=='1'"
                                         @click.stop="modifyWorkorderBz(item)">
                                        <el-icon>
                                            <edit/>
                                        </el-icon>
                                    </div>
                                    <div class="wordordeExplain_list_delete" v-if="item.sfbr=='1'"
                                         @click="deletWorkorderBz(item.bzId)">
                                        <el-icon>
                                            <delete/>
                                        </el-icon>
                                    </div>
                                </div>
                                <div class="wordordeExplain_list_xqBottom">
                                    {{item.bzText}}
                                </div>
                            </div>
                        </div>
                        <!--<div class="wordordeExplain_list">-->
                        <!--<span class="icon-ico_woman wordordeExplain_list_icon"><span class="path1"></span><span-->
                        <!--class="path2"></span></span>-->
                        <!--<div class="wordordeExplain_list_xq">-->
                        <!--<div class="wordordeExplain_list_xqTop">-->
                        <!--<span>派单组</span><span class="wordordeExplain_list_xqTop_name">周莱来</span>-->
                        <!--<div class="wordordeExplain_list_xqTop_time">-->
                        <!--2021-01-02 14:56:45-->
                        <!--</div>-->
                        <!--</div>-->
                        <!--<div class="wordordeExplain_list_xqBottom">-->
                        <!--来电人电话不通-->
                        <!--</div>-->
                        <!--</div>-->
                        <!--</div>-->
                        <div class="wordordeExplain_textarea">
                            <div class="wordordeExplain_textarea_label">
                                备注
                            </div>
                            <el-input
                                :rows="2"
                                type="textarea"
                                placeholder="请输入"
                                v-model="addWorkorderBzText"
                            />
                        </div>
                        <div class="wordordeExplain_btn">
                            <button @click="addWordorderBz">确定</button>
                        </div>
                    </div>
                    <div class="wordordeExplain_modal" @click.stop v-if="modifyWorkorderBzObj"
                         :style="{'display':workorderBzModifyModal}">
                        <div class="wordordeExplain_list">
                        <span class="icon-ico_man wordordeExplain_list_icon"><span class="path1"></span><span
                            class="path2"></span></span>
                            <div class="wordordeExplain_list_xq">
                                <div class="wordordeExplain_list_xqTop">
                                    <span>{{modifyWorkorderBzObj.bzBzdw}}</span><span
                                    class="wordordeExplain_list_xqTop_name">{{modifyWorkorderBzObj.bzBzr}}</span>
                                    <div class="wordordeExplain_list_xqTop_time">
                                        {{modifyWorkorderBzObj.createTime}}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="wordordeExplain_textarea">
                            <div class="wordordeExplain_textarea_label">
                                备注
                            </div>
                            <el-input
                                :rows="2"
                                type="textarea"
                                placeholder="请输入"
                                v-model="modifyWorkorderBzText"
                            />
                        </div>
                        <div class="wordordeExplain_btn">
                            <button @click="wordorderBzModifyBack">返回</button>
                            <button @click="modifyWordorderBz(modifyWorkorderBzObj.bzId)">确定</button>
                        </div>
                    </div>
                </div>
                <div class="hotline_left_title">
                    <div class="hotline_left_t_name">
                        <p>工单详情</p>
                        <div class="hotline_left_tn_tip">
                            智能识别
                        </div>
                    </div>
                    <div class="hotline_left_t_edit" @click="editWorkOrder" v-if="editBtnShow">
                        编辑
                    </div>
                </div>
                <div class="hotline_left_echo">
                    <div class="hotline_left_echo_title">
                        <span class="hotline_left_et_verticalLine"></span>
                        <p>工单信息</p>
                    </div>
                    <table class="hotline_left_table" border style="width: 100%;table-layout:fixed;">
                        <tbody>
                        <tr>
                            <td class="hotline_left_tableLabel">
                                <div>工单编号</div>
                            </td>
                            <td>{{wordOrderIputInformation.gdGdbh}}
                                <el-icon @click="copyText(wordOrderIputInformation.gdGdbh)">
                                    <document-copy/>
                                </el-icon>
                            </td>
                            <td class="hotline_left_tableLabel">
                                <div>上报人</div>
                            </td>
                            <td>{{wordOrderIputInformation.gdSbrmc}}</td>
                        </tr>
                        <tr>
                            <td class="hotline_left_tableLabel">
                                <div>工单级别</div>
                            </td>
                            <td>{{wordOrderIputInformation.gdGdjb}}</td>
                            <td class="hotline_left_tableLabel">
                                <div>上报时间</div>
                            </td>
                            <td>{{wordOrderIputInformation.gdSbsj}}</td>
                        </tr>
                        </tbody>
                    </table>

                    <div class="hotline_left_echo_title">
                        <span class="hotline_left_et_verticalLine"></span>
                        <p>反映问题</p>
                    </div>
                    <table class="hotline_left_table" border style="width: 100%;table-layout:fixed">
                        <tbody>
                        <tr>
                            <td class="hotline_left_tableLabel">
                                <div>工单标题</div>
                            </td>
                            <td class="hotline_left_tableTextaera">{{wordOrderIputInformation.gdBt}}</td>
                        </tr>
                        <tr class="hotline_left_table_heightauto">
                            <td class="hotline_left_tableLabel">
                                <div>
                                    主要内容
                                </div>
                            </td>
                            <td class="hotline_left_tableTextaera">
                                {{wordOrderIputInformation.gdZynr}}
                            </td>
                        </tr>
                        <tr>
                            <td class="hotline_left_tableLabel">
                                <div>所在网格</div>
                            </td>
                            <td class="hotline_left_tableTextaera">{{wordOrderIputInformation.gdSzwgDic}}</td>
                        </tr>
                        <tr>
                            <td class="hotline_left_tableLabel">
                                <div>案发村社</div>
                            </td>
                            <td class="hotline_left_tableTextaera">{{wordOrderIputInformation.gdAfcsDic}}</td>
                        </tr>
                        <tr>
                            <td class="hotline_left_tableLabel">
                                <div>发生地址</div>
                            </td>
                            <td class="hotline_left_tableTextaera">{{wordOrderIputInformation.gdFsdz}}</td>
                        </tr>
                        <tr>
                            <td class="hotline_left_tableLabel">
                                <div>事件类型</div>
                            </td>
                            <td class="hotline_left_tableTextaera">{{wordOrderIputInformation.gdSjlxDic}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div class="Jsjb_file">
                    <div class="file_subTitle">
                        <div class="file_subTitle_left">
                            <span class="file_verticalLine"></span>
                            <p>相关附件</p>
                        </div>
                    </div>
                    <!--<div class="file_list"-->
                    <!--v-if="wordOrderIputInformation.files && wordOrderIputInformation.files.length>0">-->
                    <!--<el-table :data="wordOrderIputInformation.files" style="width: 100%"-->
                    <!--@selection-change="handleSelectionChange">-->
                    <!--<el-table-column type="selection" style="width:30px"/>-->
                    <!--<el-table-column prop="fileImg" width="35">-->
                    <!--<template #default="scope">-->
                    <!--<div style="display: flex; align-items: center">-->
                    <!--<img v-if="scope.row.fileImg=='1'" class="fileIcon"-->
                    <!--src="../../assets/images/ico_pdf.png" alt="">-->
                    <!--<img v-else-if="scope.row.fileImg=='2'" class="fileIcon"-->
                    <!--src="../../assets/images/ico_word.png" alt="">-->
                    <!--<img v-else-if="scope.row.fileImg=='3'" class="fileIcon"-->
                    <!--src="../../assets/images/ico_excel.png" alt="">-->
                    <!--<img v-else-if="scope.row.fileImg=='4'" class="fileIcon"-->
                    <!--src="../../assets/images/ico_tp.png" alt="">-->
                    <!--<img v-else-if="scope.row.fileImg=='5'" class="fileIcon"-->
                    <!--src="../../assets/images/ico_yp.png" alt="">-->
                    <!--<img v-else-if="scope.row.fileImg=='6'" class="fileIcon"-->
                    <!--src="../../assets/images/ico_other.png" alt="">-->
                    <!--<img v-else class="fileIcon"-->
                    <!--src="../../assets/images/ico_other.png" alt="">-->
                    <!--</div>-->
                    <!--</template>-->
                    <!--</el-table-column>-->
                    <!--<el-table-column prop="fileName" width="300"/>-->
                    <!--<el-table-column prop="fileSizeShow"/>-->
                    <!--&lt;!&ndash;<el-table-column prop="address" min-width="25%"/>&ndash;&gt;-->
                    <!--<el-table-column align="right">-->
                    <!--<template #default="scope">-->
                    <!--<div style="display: flex; align-items: center;justify-content: right">-->
                    <!--&lt;!&ndash;<i class="icon-success-outline"></i>&ndash;&gt;-->
                    <!--<i class="icon-eye_line" @click="handleFilePreview(scope.row)"></i>-->
                    <!--<i class="icon-download_2_line" @click="handleFileDownload(scope.row)"></i>-->
                    <!--</div>-->
                    <!--</template>-->
                    <!--</el-table-column>-->
                    <!--</el-table>-->
                    <!--</div>-->
                    <div class="file_list">
                        <div class="file_list_img">
                            <div class="file_list_img_item" v-for="(item,index) in imgFileList">
                                <img :src="item.src" alt="">
                                <div class="file_list_img_modal">
                                    <i class="icon-eye_line" @click="handleImgPreview(imgFileList,item,index)"></i>
                                    <i class="icon-download_2_line" @click="handleFileDownload(item)"></i>
                                </div>
                            </div>
                        </div>
                        <div class="file_list_img">
                            <div class="file_list_img_item" v-for="(item,index) in radioFileList">
                                <img src="../../assets/images/radioImg.png" alt="">
                                <div class="file_list_img_modal">
                                    <i class="icon-eye_line" @click="handleFilePreview(item)"></i>
                                    <i class="icon-download_2_line" @click="handleFileDownload(item)"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </el-scrollbar>
        <el-scrollbar height="100%">
            <div class="hotline_right">
                <div class="hotline_right_title">
                    <p>工单处理</p>
                    <div class="hotline_right_t_btn">
                        <div class="hotline_right_tb_gdbs"
                             :style="{display:tcgzBtnDisplay}"
                             @click="workorderModal('tcgz')">
                            <i class="icon-icon_tcgz"></i>
                            <span>剔除挂账</span>
                        </div>
                        <div class="hotline_right_tb_gdbs"
                             :style="{display:gdbsBtnDisplay}"
                             @click="gdMarkerShow=true">
                            <i class="icon-gdbs"></i>
                            <span>工单标识</span>
                        </div>
                        <div class="hotline_right_tb_gddb"
                             :style="{display:gddbBtnDisplay}"
                             @click="workerGddbShow = true">
                            <i class="icon-eye_line"></i>
                            <span>工单督办</span>
                        </div>
                        <div class="hotline_right_tb_gdcb"
                             :style="{display:gdcbBtnDisplay}"
                             @click="workorderModal('gdcb')">
                            <i class="icon-icon_gdcb"></i>
                            <span>工单催办</span>
                        </div>
                        <div class="hotline_right_tb_gdsc"
                             :style="{display:gdscBtnDisplay}"
                             @click="workorderModal('gdsc')">
                            <i class="icon-icon_gdsc"></i>
                            <span>工单删除</span>
                        </div>
                    </div>
                </div>
                <component v-if="workerGddbShow" @gdChildToParent="gdChildToParent" @workerGddbCancle="workerGddbCancle"
                           :gdId="gdId" is="Workorder_GDDB"></component>
                <div class="hotline_mark" v-if="gdMarkerShow">
                    <div class="hotline_mark_name">
                        <i class="icon-icon_tip"></i>标记标签
                    </div>
                    <div class="hotline_mark_all">
                        <div class="hotline_mark_list" @click="gdMarkClick(index)" :class="{'active':item.type=='1'}"
                             v-for="(item,index) in gdbsData">
                            <div>
                                {{item.label}}
                            </div>
                        </div>

                    </div>
                    <div class="hotline_mark_btn">
                        <div class="hotline_mark_btn_cancle" @click="gdMarkerShow=false">
                            取消
                        </div>
                        <div class="hotline_mark_btn_sure" @click="gdMarkerSave">
                            确认
                        </div>
                    </div>
                </div>
                <div class="hotline_right_workprocess" v-if="workOrderTab && workOrderTab.length>0">
                    <div class="hotline_right_workprocess_btn">
                        <div v-for="item in workOrderTab" class="hotline_right_wb_list"
                             :class="{'active':formComponentNameActive==item.bizFun}"
                             @click="changeFormComponent(item)">
                            <i :class="'icon-'+item.icon+'' "></i>
                            <span>{{item.text}}</span>
                        </div>
                    </div>
                    <component @gdChildToParent="gdChildToParent" @workorderCancle="workorderCancle" :gdId="gdId"
                               :thqx="thqx" :timeCzJz="wordOrderIputInformation" :is="formComponentName"></component>
                </div>
                <div class="hotline_progress">
                    <div class="hotline_progress_tabs">
                        <div class="hotline_progress_tabs_item">
                            <div class="hotline_progress_tabs_line">

                            </div>
                            <div class="hotline_progress_tabs_circle">

                            </div>
                            <div class="hotline_progress_tabs_line">

                            </div>
                        </div>
                        <div class="hotline_progress_tabs_item">
                            <div class="hotline_progress_tabs_line">

                            </div>
                            <div class="hotline_progress_tabs_circle">

                            </div>
                            <div class="hotline_progress_tabs_line">

                            </div>
                        </div>
                        <div class="hotline_progress_tabs_item">
                            <div class="hotline_progress_tabs_line">

                            </div>
                            <div class="hotline_progress_tabs_circle">

                            </div>
                            <div class="hotline_progress_tabs_line">

                            </div>
                        </div>
                        <div class="hotline_progress_tabs_item">
                            <div class="hotline_progress_tabs_line">

                            </div>
                            <div class="hotline_progress_tabs_circle">

                            </div>
                            <div class="hotline_progress_tabs_line">

                            </div>
                        </div>
                    </div>
                    <div class="hotline_progress_table">
                        <div class="hotline_progress_table_row">
                            <div class="hotline_progress_table_row_name">
                                上报
                            </div>
                            <div class="hotline_progress_table_row_tbody">
                                <div class="hotline_progress_table_row_col" v-for="(item,index) in progressList.sb">
                                    <div class="hotline_progress_department" v-if="item.czFpdxmc"
                                         :title="item.czFpdxmc">
                                        <span v-if="item.czFpsfzz == '1'">主</span> {{item.czFpdxmc}}
                                    </div>
                                    <div :class="progressSgcActive=='sb'+item1+index?'active':''"
                                         class="hotline_progress_department_shen" v-for="item1 in item.jdgn"
                                         @click="progressShenGuiCui(item,item1,'sb',index)">
                                        {{item1=="JGSH"?"审":item1=="GDGD"?"归":item1=="GDCB"?"催":item1=="THSH"?"退":""}}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="hotline_progress_table_row">
                            <div class="hotline_progress_table_row_name">
                                处置
                            </div>
                            <div class="hotline_progress_table_row_tbody">
                                <div class="hotline_progress_table_row_col" v-for="(item,index) in progressList.cz">
                                    <div class="hotline_progress_department" v-if="item.czFpdxmc"
                                         :title="item.czFpdxmc">
                                        <span v-if="item.czFpsfzz == '1'">主</span> {{item.czFpdxmc}}
                                    </div>
                                    <div :class="progressSgcActive=='cz'+item1+index?'active':''"
                                         class="hotline_progress_department_shen" v-for="item1 in item.jdgn"
                                         @click="progressShenGuiCui(item,item1,'cz',index)">
                                        {{item1=="JGSH"?"审":item1=="GDGD"?"归":item1=="GDCB"?"催":item1=="THSH"?"退":""}}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="hotline_progress_table_row">
                            <div class="hotline_progress_table_row_name">
                                审核
                            </div>
                            <div class="hotline_progress_table_row_tbody">
                                <div class="hotline_progress_table_row_col" v-for="(item,index) in progressList.sh">
                                    <div class="hotline_progress_department" v-if="item.czFpdxmc"
                                         :title="item.czFpdxmc">
                                        <span v-if="item.czFpsfzz == '1'">主</span> {{item.czFpdxmc}}
                                    </div>
                                    <div :class="progressSgcActive=='sh'+item1+index?'active':''"
                                         class="hotline_progress_department_shen" v-for="item1 in item.jdgn"
                                         @click="progressShenGuiCui(item,item1,'sh',index)">
                                        {{item1=="JGSH"?"审":item1=="GDGD"?"归":item1=="GDCB"?"催":item1=="THSH"?"退":""}}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="hotline_progress_table_row">
                            <div class="hotline_progress_table_row_name">
                                办结
                            </div>
                            <div class="hotline_progress_table_row_tbody">
                                <div class="hotline_progress_table_row_col" v-for="(item,index) in progressList.bj">
                                    <div class="hotline_progress_department" v-if="item.czFpdxmc"
                                         :title="item.czFpdxmc">
                                        <span v-if="item.czFpsfzz == '1'">主</span> {{item.czFpdxmc}}
                                    </div>
                                    <div :class="progressSgcActive=='bj'+item1+index?'active':''"
                                         class="hotline_progress_department_shen" v-for="item1 in item.jdgn"
                                         @click="progressShenGuiCui(item,item1,'bj',index)">
                                        {{item1=="JGSH"?"审":item1=="GDGD"?"归":item1=="GDCB"?"催":item1=="THSH"?"退":""}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <component :gdId="gdId" @workProgressSure="workProgressSure"
                               @workProgressCancle="workProgressCancle"
                               :workProgressComponentChildData="workProgressComponentChildData"
                               :is="WorkProgressComponentName"></component>
                </div>
                <div class="hotline_identifying" v-if="selectedMarkerList && selectedMarkerList.length>0">
                    <div class="hotline_identifying_list" v-for="item in selectedMarkerList">
                        <span><span></span></span>{{item.label}}
                    </div>
                </div>
                <div class="hotline_right_timeline">
                    <div class="hotline_right_timeline_title">
                        <span class="hotline_right_timeline_title_verticalLine"></span>
                        <p>工单进度</p>
                    </div>
                    <timeLine ref="timeLineRef"></timeLine>
                </div>
            </div>
            <div class="hotline_right_btn">
                <div>
                    <div class="hotline_right_btn_list" @click="viewAllProgress">
                        <span class="icon-ico_ckqbjd"></span>查看全部进度
                    </div>
                    <div class="hotline_right_btn_list">
                        <span class="icon-ico_xzlct"></span>下载流程图
                    </div>
                </div>
            </div>
        </el-scrollbar>
    </div>
    <div class="modal" :style="{display:workorderModalDisplay=='gdbs'?'block':'none'}">
        <div class="modal_content modal_content_gdbs">
            <div class="modal_gdbs_title">
                <el-icon>
                    <info-filled/>
                </el-icon>
                工单标识
            </div>
            <div class="modal_gdbs_btn">
                <div class="modal_gdbs_btn_cancle" @click="workorderModal('')">
                    取消
                </div>
                <div class="modal_gdbs_btn_sure">
                    确认
                </div>
            </div>
        </div>
    </div>
    <div class="modal" :style="{display:workorderModalDisplay=='gddb'?'block':'none'}">
        <div class="modal_content modal_content_gdbs">
            <div class="modal_gdbs_title">
                <el-icon>
                    <info-filled/>
                </el-icon>
                工单督办
            </div>
            <div class="modal_gdbs_btn">
                <div class="modal_gdbs_btn_cancle" @click="workorderModal('')">
                    取消
                </div>
                <div class="modal_gdbs_btn_sure" @click="wordorderDb">
                    确认
                </div>
            </div>
        </div>
    </div>
    <div class="modal" :style="{display:workorderModalDisplay=='gdcb'?'block':'none'}">
        <div class="modal_content modal_content_gdbs">
            <div class="modal_gdbs_title">
                <el-icon>
                    <info-filled/>
                </el-icon>
                工单催办
            </div>
            <div class="modal_gdbs_btn">
                <div class="modal_gdbs_btn_cancle" @click="workorderModal('')">
                    取消
                </div>
                <div class="modal_gdbs_btn_sure" @click="wordorderCb">
                    确认
                </div>
            </div>
        </div>
    </div>
    <div class="modal" :style="{display:workorderModalDisplay=='gdsc'?'block':'none'}">
        <div class="modal_content modal_content_gdbs">
            <div class="modal_gdbs_title">
                <el-icon>
                    <info-filled/>
                </el-icon>
                工单删除
            </div>
            <div class="modal_gdbs_btn">
                <div class="modal_gdbs_btn_cancle" @click="workorderModal('')">
                    取消
                </div>
                <div class="modal_gdbs_btn_sure" @click="wordorderSc">
                    确认
                </div>
            </div>
        </div>
    </div>
    <div class="modal" :style="{display:workorderModalDisplay=='gdsc'?'block':'none'}">
        <div class="modal_content modal_content_gdbs">
            <div class="modal_gdbs_title">
                <el-icon>
                    <info-filled/>
                </el-icon>
                工单删除
            </div>
            <div class="modal_gdbs_btn">
                <div class="modal_gdbs_btn_cancle" @click="workorderModal('')">
                    取消
                </div>
                <div class="modal_gdbs_btn_sure" @click="wordorderSc">
                    确认
                </div>
            </div>
        </div>
    </div>
    <ImgCarousel ref="imgCarouselChild" :imgList="imgList" :imgListIndex="imgListIndex"></ImgCarousel>
</template>

<script>
    import {reactive, watch, ref, onMounted, getCurrentInstance, provide, onBeforeUnmount} from 'vue';
    import {ElMessageBox, ElLoading, ElMessage} from 'element-plus';
    import {useStore} from 'vuex'
    import {
        workOrderTabMapName,
        workOrderTabMapComponent,
        workOrderTabIcon,
        filePreview,
        fileDownload
    } from '../../assets/js/base.js';
    import File from '@/components/EventManage/Jsjb/File.vue';
    import timeLine from '@/components/EventManage/Jsjb/TimeLine.vue';
    // import Wordorder_PSTS from '@/components/WorkorderForm/Wordorder_PSTS.vue';//批示推送
    // import Workorder_CZJGSH_ZGLD from '@/components/WorkorderForm/Workorder_CZJGSH_ZGLD.vue';//处置结果审核
    // import Workorder_CZJGSH_ZX from '@/components/WorkorderForm/Workorder_CZJGSH_ZX.vue';//处置结果审核
    // import Workorder_GDHF_ZX from '@/components/WorkorderForm/Workorder_GDHF_ZX.vue';//处置结果审核--工单回访
    // import Workorder_TJCZJG from '@/components/WorkorderForm/Workorder_TJCZJG.vue';//工单回访--提交处置结果
    // import Workorder_GDHF from '@/components/WorkorderForm/Workorder_GDHF.vue';//工单回访--工单回访
    // import Workorder_GDFP from '@/components/WorkorderForm/Workorder_GDFP.vue';//工单分派
    // import Workorder_GDQS from '@/components/WorkorderForm/Workorder_GDQS.vue';//工单签收
    // import Workorder_GDPS from '@/components/WorkorderForm/Workorder_GDPS.vue';//工单批示
    // import Workorder_SQTH from '@/components/WorkorderForm/Workorder_GDTH.vue';//申请退回
    // import Workorder_THSH from '@/components/WorkorderForm/Workorder_THSH.vue';//退回审核
    import Workorder_GDCZ from '@/components/WorkorderForm/Workorder_GDCZ.vue';//退回处置
    import Workorder_GDFP from '@/components/WorkorderForm/Workorder_GDFP.vue';//工单分派
    import Workorder_JGSH from '@/components/WorkorderForm/Workorder_JGSH.vue';//结果审核
    import Workorder_DBCC from '@/components/WorkorderForm/Workorder_DBCC.vue';//督办抽查
    import Workorder_THSH from '@/components/WorkorderForm/Workorder_THSH.vue';//退回审核
    import Workorder_GDQS from '@/components/WorkorderForm/Workorder_GDQS.vue';//工单签收
    import Workorder_GDTH from '@/components/WorkorderForm/Workorder_GDTH.vue';//工单退回
    import Workorder_GDGP from '@/components/WorkorderForm/Workorder_GDGP.vue';//工单改派
    import Workorder_GDTS from '@/components/WorkorderForm/Workorder_GDTS.vue';//工单推送
    import Workorder_GDYQ from '@/components/WorkorderForm/Workorder_GDYQ.vue';//工单延期
    import Workorder_CXFP from '@/components/WorkorderForm/Workorder_CXFP.vue';//重新分派
    import Workorder_GDJP from '@/components/WorkorderForm/Workorder_GDJP.vue';//工单加派
    import Workorder_GDBH from '@/components/WorkorderForm/Workorder_GDBH.vue';//工单驳回
    import Workorder_GDDB from '@/components/WorkorderForm/Workorder_GDDB.vue';//工单督办t
    import Workorder_CXFQ from '@/components/WorkorderForm/Workorder_CXFQ.vue';//重新发起
    import Workorder_GDGD from '@/components/WorkorderForm/Workorder_GDGD.vue';//工单归档
    import Workorder_XGLX from '@/components/WorkorderForm/Workorder_XGLX.vue';//修改类型
    import Workorder_HGJC from '@/components/WorkorderForm/Workorder_HGJC.vue';//合格检查
    import ImgCarousel from '@/components/ImgCarousel/ImgCarousel.vue';//重新分派

    import WorkProgress_cb from '@/components/WorkProgress/WorkProgress_cb.vue';//流程催办
    import WorkProgress_gd from '@/components/WorkProgress/WorkProgress_gd.vue';//流程归档
    import WorkProgress_sh from '@/components/WorkProgress/WorkProgress_sh.vue';//流程审核
    import WorkProgress_th from '@/components/WorkProgress/WorkProgress_th.vue';//流程退回审核

    export default {
        name: "Hotline",
        props: ["parentToChild"],
        components: {
            File,
            timeLine,
            // Wordorder_PSTS,
            // Workorder_CZJGSH_ZGLD,
            // Workorder_CZJGSH_ZX,
            // Workorder_GDHF_ZX,
            // Workorder_TJCZJG,
            // Workorder_GDHF,
            // Workorder_GDFP,
            // Workorder_GDQS,
            // Workorder_GDPS,
            // Workorder_SQTH,
            // Workorder_THSH,
            Workorder_GDCZ,
            Workorder_GDFP,
            Workorder_JGSH,
            Workorder_DBCC,
            Workorder_THSH,
            Workorder_GDQS,
            Workorder_GDTH,
            Workorder_GDGP,
            Workorder_GDTS,
            Workorder_GDYQ,
            Workorder_CXFP,
            Workorder_GDJP,
            Workorder_GDBH,
            Workorder_GDDB,
            Workorder_CXFQ,
            Workorder_GDGD,
            Workorder_XGLX,
            Workorder_HGJC,
            ImgCarousel,
            WorkProgress_cb,
            WorkProgress_gd,
            WorkProgress_sh,
            WorkProgress_th
        },
        setup(props, context) {
            // provide("gdId",props.parentToChild.gdId);
            provide("gdId", ref(props.parentToChild.gdId));
            const {proxy} = getCurrentInstance();
            const store = useStore();
            const timeLineRef = ref(null)//子组件timeLine
            let gdId = props.parentToChild.gdId;
            // let gdId = ref();
            let wordOrderIputInformation = ref({
                gdGdbh: "",
                gdSbrmc: "",
                gdSbsj: "",
                gdBt: "",
                gdFsdz: "",
                gdZynr: "",
                gdSjlx: "",
                gdFsdzJd: "",
                gdFsdzWd: "",
                files: [],
                gdGdlx: "",
                gdAfcs: "",
                gdAfcsDic: "",
                gdSjlxDic: "",
                gdGdlxDic: "",
                gdGdjb:"",
                gdSzwgDic:""
            })
            const activities = reactive();
            let workOrderTab = ref();//工单tab数组
            const gdTabAjax = () => {
                proxy.$axios.post("/jgfast/wgsj/selGdjdgn", props.parentToChild).then((res) => {
                    formComponentName.value = "";
                    formComponentNameActive.value = "";
                    editBtnShow.value = false
                    if (res.data) {
                        res.data.map((param, index) => {
                            // param.name = workOrderTabMapName[param.bizFun];
                            if (param.bizFun == 'GDXG') {
                                res.data.splice(index, 1)
                                editBtnShow.value = true
                            } else {
                                param.icon = workOrderTabIcon[param.bizFun];
                                return param
                            }
                        })
                        workOrderTab.value = res.data;
                    } else {
                        workOrderTab.value = null;
                    }
                }).catch((e) => {

                });
            }
            onMounted(() => {
                gdTabAjax();
                workorderInformation();
                document.addEventListener("click", bodyCloseWorkorderBzModal);
            });
            let formComponentName = ref()
            let formComponentNameActive = ref();
            //申请退回判断取消是否向后台发送事件
            let thqx = ref();
            const changeFormComponent = (param) => {
                formComponentName.value = workOrderTabMapComponent[param.bizFun];
                formComponentNameActive.value = param.bizFun;
                if (param.thqx) {
                    thqx.value = param.thqx;
                }
            }
            const workorderModalDisplay = ref();
            const workorderModal = (param) => {
                if (!param) {
                    workorderModalDisplay.value = "";
                } else {
                    workorderModalDisplay.value = param;
                }
            }
            //工单处置子组件向父组件触发事件
            const gdChildToParent = (param) => {
                if (param == 'gddb') {
                    timeLineRef.value.timeLine();//工单处置流程
                    workerGddbShow.value = false
                } else if (param == 'xgxl') {
                    gdTabAjax();
                    gdjdAjax();
                    // getWorkorderHandleFunctionButton();//工单处置功能按钮
                    timeLineRef.value.timeLine();//工单处置流程
                    workorderInformation();//工单详情
                } else {
                    gdTabAjax();
                    gdjdAjax();
                    // getWorkorderHandleFunctionButton();//工单处置功能按钮
                    timeLineRef.value.timeLine();//工单处置流程
                }
            }
            //工单处置取消
            const workorderCancle = (param) => {
                formComponentName.value = "";
                formComponentNameActive.value = "";
                // if (param == "1") {
                //     gdTabAjax();
                //     timeLineRef.value.timeLine();//工单处置流程
                // }
            }
            //工单详情查询
            //相关附件图片和视频
            let imgFileList = ref([])
            let radioFileList = ref([])
            const workorderInformation = () => {
                imgFileList.value = []
                radioFileList.value = []
                proxy.$axios.post("/jgfast/wgsj/selGdxxxq", {
                    "gdId": gdId
                }).then((res) => {
                    wordOrderIputInformation.value = res.data;
                    if (res.data.sfsc == 1) {
                        wordOrderCollect.value = true
                    } else {
                        wordOrderCollect.value = false
                    }
                    res.data.files.map(item => {
                        if (item.fileImg == 4) {
                            item.src = "/jgfast/sys/comm/fileUploadView?fileId=" + item.fileId
                            imgFileList.value.push(item)
                        } else if (item.fileImg == 6) {
                            radioFileList.value.push(item)
                        }
                    })
                });
            }
            //工单详情收藏
            let wordOrderCollect = ref(false);
            const wordOrderCollectFun = () => {
                let url = "";
                if (wordOrderCollect.value) {
                    url = "/jgfast/wgsj/delScgd";
                } else {
                    url = "/jgfast/wgsj/insScgd";
                }
                proxy.$axios.post(url, {
                    "gdId": gdId
                }).then((res) => {
                    wordOrderCollect.value = !wordOrderCollect.value
                });
            }
            //获取工单处置功能按钮
            let workorderHandleFunctionButtonArray = ref([])
            const getWorkorderHandleFunctionButton = () => {
                proxy.$axios.post("/jgfast/wgsj/selGdczgn", {
                    "gdId": gdId
                }).then((res) => {
                    workorderHandleFunctionButtonArray.value = res.data;
                    filterWorkorderHandleFunctionButton(res.data)
                });
            }
            //过滤是否显示对应的工单处置功能按钮
            const tcgzBtnDisplay = ref('none');
            const gdbsBtnDisplay = ref('none');
            const gddbBtnDisplay = ref('none');
            const gdcbBtnDisplay = ref('none');
            const gdscBtnDisplay = ref('none');
            const filterWorkorderHandleFunctionButton = (param) => {
                if (param && param.length) {
                    workorderHandleFunctionButtonArray.value.map(item => {
                        if (item.bizFun == "TCGZ") {
                            tcgzBtnDisplay.value = "flex"
                        } else if (item.bizFun == "GDBS") {
                            gdbsBtnDisplay.value = "flex"
                        } else if (item.bizFun == "GDDB") {
                            gddbBtnDisplay.value = "flex"
                        } else if (item.bizFun == "GDCB") {
                            gdcbBtnDisplay.value = "flex"
                        } else if (item.bizFun == "GDSC") {
                            gdscBtnDisplay.value = "flex"
                        }
                    })
                }
            }
            //全屏加载
            let loadingFullScreen;
            const openFullScreen = () => {
                loadingFullScreen = ElLoading.service({
                    lock: true,
                    text: 'Loading',
                    background: 'rgba(0, 0, 0, 0.7)',
                })
            }
            //工单督办
            const wordorderDb = () => {
                workorderModalDisplay.value = "";
                openFullScreen();
                proxy.$axios.post("/jgfast/wgsj/gdcz", {
                    "gdId": gdId,
                    czCzlx: "GDDB"
                }).then((res) => {
                    loadingFullScreen.close()
                    timeLineRef.value.timeLine();
                }).catch(e => {
                    loadingFullScreen.close()
                });
            }
            //工单催办
            const wordorderCb = () => {
                workorderModalDisplay.value = "";
                openFullScreen();
                proxy.$axios.post("/jgfast/wgsj/gdcz", {
                    "gdId": gdId,
                    czCzlx: "GDCB"
                }).then((res) => {
                    loadingFullScreen.close()
                    timeLineRef.value.timeLine();
                }).catch(e => {
                    loadingFullScreen.close()
                });
            }
            //工单删除
            const wordorderSc = () => {
                workorderModalDisplay.value = "";
                openFullScreen();
                proxy.$axios.post("/jgfast/wgsj/gdcz", {
                    "gdId": gdId,
                    "czCzlx": 'GDSC'
                }).then((res) => {
                    loadingFullScreen.close()
                    ElMessage({
                        showClose: false,
                        message: '删除成功',
                        center: true,
                        duration: "2000"
                    })
                    setTimeout(() => {
                        store.state.addNewWorkorderSuccess = true;
                        // timeLineRef.value.timeLine();
                        store.commit("deletLeftTreeToHeaderTab", wordOrderIputInformation.value.gdGdbh);
                        store.state.headerActiveTab = store.state.leftTreeToHeaderTab[store.state.leftTreeToHeaderTab.length - 1].label;
                    }, 2000)

                }).catch(e => {
                    loadingFullScreen.close()
                });
            }
            //工单备注弹框显示隐藏
            let workorderBzModal = ref("none");
            const openWorkorderBzModal = () => {
                workorderBzModal.value = "block";
            }
            let workorderBzModifyModal = ref("none");
            // const openWorkorderBzModifyModal = () => {
            //     workorderBzModifyModal.value = "block";
            // }
            const bodyCloseWorkorderBzModal = () => {
                if (workorderBzModal.value == "block") {
                    workorderBzModal.value = "none";
                }
            }
            onBeforeUnmount(() => {
                document.removeEventListener("click", bodyCloseWorkorderBzModal);
            })
            //查询工单备注
            let wordorderBzCon = ref()
            const queryWorkorderBz = () => {
                proxy.$axios.post("/jgfast/wgsj/selGdxxbz", {
                    "gdId": gdId,
                }).then((res) => {
                    wordorderBzCon.value = res.data;
                });
            }
            //新增备注
            let addWorkorderBzText = ref();
            const addWordorderBz = () => {
                proxy.$axios.post("/jgfast/wgsj/insGdxxbz", {
                    "gdId": gdId,
                    "bzText": addWorkorderBzText.value
                }).then((res) => {
                    addWorkorderBzText.value = "";
                    // queryWorkorderBz();
                    // workorderBzModal.value ="none";
                });
            }
            //删除备注
            const deletWorkorderBz = (param) => {
                ElMessageBox.confirm('请确认是否要删除', '提示', {
                    confirmButtonText: '确认',
                    cancelButtonText: '取消',
                    callback: (action) => {
                        if (action == "confirm") {
                            proxy.$axios.post("/jgfast/wgsj/delGdxxbz", {
                                "gdId": gdId,
                                "bzId": param
                            }).then((res) => {
                                queryWorkorderBz()
                            });
                        }
                    },
                })

            }
            //修改备注
            let modifyWorkorderBzObj = ref(null);
            const modifyWorkorderBz = (param) => {
                modifyWorkorderBzObj.value = param;
                workorderBzModal.value = "none";
                workorderBzModifyModal.value = "block";
                modifyWorkorderBzText.value = param.bzText;
            }
            let modifyWorkorderBzText = ref();
            const wordorderBzModifyBack = () => {
                workorderBzModal.value = "block";
                workorderBzModifyModal.value = "none";
            }
            const modifyWordorderBz = (param) => {
                proxy.$axios.post("/jgfast/wgsj/udpGdxxbz", {
                    "gdId": gdId,
                }).then((res) => {
                    queryWorkorderBz();
                    wordorderBzModifyBack();
                });
            }
            //文件查看filePreview,fileDownload
            const handleFilePreview = (param) => {
                filePreview(param.fileName, param.fileId)
            }
            //文件下载
            const handleFileDownload = (param) => {
                fileDownload(param.fileId)
            }
            //一键下载
            const oneClickDownload = () => {
                for (var i = 0; i < wordOrderIputInformation.value.files.length; i++) {
                    fileDownload(wordOrderIputInformation.value.files[i].fileId)
                }
            }
            //批量下载
            let selectedTable = ref()
            const handleSelectionChange = (param) => {
                selectedTable.value = param;
            }
            const batchDownload = () => {
                if (selectedTable.value && selectedTable.value.length > 0) {
                    for (var i = 0; i < selectedTable.value.length; i++) {
                        fileDownload(selectedTable.value[i].fileId)
                    }
                }

            }
            //复制文本
            const copyText = (param) => {
                let cInput = document.createElement("input");
                cInput.value = param;
                document.body.appendChild(cInput);
                // 选取文本框内容
                cInput.select();
                // 执行浏览器复制命令
                // 复制命令会将当前选中的内容复制到剪切板中（这里就是创建的input标签）
                // Input要在正常的编辑状态下原生复制方法才会生效
                document.execCommand("copy");
                // 复制成功后再将构造的标签 移除
                document.body.removeChild(cInput);
            }
            //查看全部进度
            const viewAllProgress = () => {
                store.commit('addLeftTreeToHeaderTab', {
                    name: "TimelineAll",
                    label: "全部进度-" + wordOrderIputInformation.value.gdGdbh,
                    linkTo: "/TimelineAll",
                    query: {
                        gdId: gdId
                    },
                });
            }
            //编辑
            const editWorkOrder = () => {
                store.commit('addLeftTreeToHeaderTab', {
                    name: "Jsjb_handInput",
                    label: "编辑-" + gdId,
                    linkTo: "/Jsjb_handInput",
                    query: {
                        gdId: gdId,
                        editBealon: true
                    },
                });
            }
            //编辑按钮是否可见
            let editBtnShow = ref(false)
            // watch(() => store.state.addMapSignTree, (newVal) => {
            //     if (newVal) {
            //         editBtnShow.value = true;
            //     } else {
            //         editBtnShow.value = false;
            //     }
            // }, {
            //     immediate: true
            // })
            //图片查看
            let imgListIndex = ref(0)
            let imgList = ref()
            let imgCarouselChild = ref()
            const handleImgPreview = (param, item, index) => {
                imgListIndex.value = index;
                imgList.value = param;
                imgCarouselChild.value.showImgCarousel()
            }
            //工单进度
            let progressList = ref([])

            const gdjdAjax = () => {
                proxy.$axios.post("/jgfast/wgsj/selGdjd", {
                    "gdId": gdId
                }).then((res) => {
                    let maxLength = 0;
                    for (var key  in res.data) {
                        maxLength = Math.max(res.data[key].length, maxLength)
                    }
                    for (var key  in res.data) {
                        let addLength = maxLength - res.data[key].length;
                        for (let i = 0; i < addLength; i++) {
                            res.data[key].push({})
                        }
                    }
                    progressList.value = res.data;
                });
            }
            //点击流程 审
            let workProgressComponentChildData = ref()
            let WorkProgressComponentName = ref("")
            let progressSgcActive = ref("")

            const progressShenGuiCui = (param, item, active, index) => {
                if (item == 'JGSH') {
                    WorkProgressComponentName.value = "WorkProgress_sh"
                } else if (item == 'GDGD') {
                    WorkProgressComponentName.value = "WorkProgress_gd"
                } else if (item == 'GDCB') {
                    WorkProgressComponentName.value = "WorkProgress_cb"
                }else if (item == 'THSH') {
                    WorkProgressComponentName.value = "WorkProgress_th"
                }
                workProgressComponentChildData.value = param
                progressSgcActive.value = active + item + index
            }
            const workProgressSure = () => {
                WorkProgressComponentName.value = "";
                progressSgcActive.value = ''
                gdjdAjax();
                gdTabAjax();
                timeLineRef.value.timeLine();//工单处置流程
            }
            const workProgressCancle = () => {
                WorkProgressComponentName.value = "";
                progressSgcActive.value = ''
            }
            //工单标识
            let gdbsData = ref();
            let gdMarkerShow = ref(false)
            let selectedMarkerList = ref([])
            const gdbsAjax = () => {
                proxy.$axios.post("/jgfast/wgsj/selGdbs", {
                    "gdId": gdId
                }).then((res) => {
                    gdbsData.value = res.data
                    res.data.map(item => {
                        if (item.type == 1) {
                            selectedMarkerList.value.push(item)
                        }
                    })
                });
            }
            const gdMarkClick = (index) => {
                if (gdbsData.value[index].type == '1') {
                    gdbsData.value[index].type = "0"
                } else {
                    gdbsData.value[index].type = "1"
                }

            }
            const gdMarkerSave = () => {
                let gdGdbsArray = [];
                gdbsData.value.map(item => {
                    if (item.type == '1') {
                        gdGdbsArray.push(item.value)
                    }
                })
                proxy.$axios.post("/jgfast/wgsj/saveGdbs", {
                    "gdId": gdId,
                    gdGdbs: gdGdbsArray.join(",")
                }).then((res) => {
                    gdMarkerShow.value = false;
                    selectedMarkerList.value = []
                    gdbsData.value.map(item => {
                        if (item.type == '1') {
                            selectedMarkerList.value.push(item)
                        }
                    })
                });
            }
            //工单督办
            let workerGddbShow = ref(false)
            const workerGddbCancle = () => {
                workerGddbShow.value = false
            }
            //刷新这个页面数据
            watch(() => store.state.gdxgRefreshData, (newVal) => {
                if (newVal) {
                    store.state.gdxgRefreshData = false;
                    gdTabAjax();
                    gdjdAjax();
                    // getWorkorderHandleFunctionButton();//工单处置功能按钮
                    timeLineRef.value.timeLine();//工单处置流程
                    workorderInformation();//工单详情
                }
            })
            onMounted(() => {
                // getWorkorderHandleFunctionButton();
                gdjdAjax()
                // gdbsAjax()
                // queryWorkorderBz();//查询工单备注
            })
            return {
                activities,
                formComponentName,
                changeFormComponent,
                workorderModalDisplay,
                workorderModal,
                workOrderTab,
                formComponentNameActive,
                gdId,
                gdChildToParent,
                wordOrderIputInformation,
                wordOrderCollect,
                workorderHandleFunctionButtonArray,
                wordorderCb,
                wordorderDb,
                timeLineRef,
                workorderBzModal,
                openWorkorderBzModal,
                wordorderBzCon,
                addWorkorderBzText,
                addWordorderBz,
                deletWorkorderBz,
                workorderBzModifyModal,
                modifyWorkorderBzObj,
                modifyWorkorderBz,
                modifyWorkorderBzText,
                wordorderBzModifyBack,
                modifyWordorderBz,
                thqx,
                workorderCancle,
                handleFilePreview,
                handleFileDownload,
                copyText,
                handleSelectionChange,
                tcgzBtnDisplay,
                gdbsBtnDisplay,
                gddbBtnDisplay,
                gdcbBtnDisplay,
                gdscBtnDisplay,
                viewAllProgress,
                wordorderSc,
                editWorkOrder,
                editBtnShow,
                handleImgPreview,
                imgListIndex,
                imgList,
                imgFileList,
                radioFileList,
                imgCarouselChild,
                progressShenGuiCui,
                WorkProgressComponentName,
                progressList,
                workProgressComponentChildData,
                progressSgcActive,
                gdbsData,
                gdMarkClick,
                gdMarkerSave,
                gdMarkerShow,
                workerGddbShow,
                workerGddbCancle,
                workProgressSure,
                workProgressCancle,
                selectedMarkerList,
            }
        }
    }
</script>

<style scoped>

</style>
